import {Localizer} from "../../../infrastructure/localization/localizer";

export enum KompetenceDatoKategoriEnum {
    UnderEnUge = 1,
    OverEnUge = 2,
    OverEnMaaned = 3,
    OverTreMaaneder = 4,
    IngenAktivitet = 5,
}

export function GetKompetenceTimeString(status: KompetenceDatoKategoriEnum): string {
    switch (status) {
        case KompetenceDatoKategoriEnum.IngenAktivitet:
            return Localizer.dashboard_ingenAktivitet();
        case KompetenceDatoKategoriEnum.UnderEnUge:
            return Localizer.dashboard_underEnUge();
        case KompetenceDatoKategoriEnum.OverEnUge:
            return Localizer.dashboard_overEnUge();
        case KompetenceDatoKategoriEnum.OverEnMaaned:
            return Localizer.dashboard_overEnMaaned();
        case KompetenceDatoKategoriEnum.OverTreMaaneder:
            return Localizer.dashboard_overTreMaaneder();
        default:
            return "";
    }
}

export const getMinMaxKompetenceDage = (value: KompetenceDatoKategoriEnum): [number | undefined, number | undefined] => {
    switch (value) {
        case KompetenceDatoKategoriEnum.UnderEnUge:
            return [0, 6];
        case KompetenceDatoKategoriEnum.OverEnUge:
            return [7, 30];
        case KompetenceDatoKategoriEnum.OverEnMaaned:
            return [31, 90];
        case KompetenceDatoKategoriEnum.OverTreMaaneder:
            return [91, undefined];
        case KompetenceDatoKategoriEnum.IngenAktivitet:
            return [-1, -1];
        default:
            return [undefined, undefined];
    }
}

